"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingPoiIcon = MissingPoiIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function MissingPoiIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_5645_25730)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#E4F2DE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.0006 6.66675C14.8539 6.66675 10.6672 10.8534 10.6672 16.0001C10.6672 21.6103 16.6623 29.3616 19.0429 32.2184C19.5486 32.8252 20.4526 32.8252 20.9582 32.2184C23.3388 29.3616 29.3339 21.6103 29.3339 16.0001C29.3339 10.8534 25.1472 6.66675 20.0006 6.66675ZM21.1739 23.8334C21.1739 24.4777 20.6516 25.0001 20.0072 25.0001C19.3629 25.0001 18.8406 24.4777 18.8406 23.8334C18.8406 23.1891 19.3629 22.6667 20.0072 22.6667C20.6516 22.6667 21.1739 23.1891 21.1739 23.8334ZM21.4265 20.0442C21.1468 20.6247 20.6516 21.1734 20.0072 21.1734C19.3629 21.1734 18.8172 20.6409 18.9695 20.0148C19.6005 17.4193 22.3339 17.4092 22.3339 15.3334C22.3339 14.0534 21.2806 13.0001 20.0006 13.0001C19.1244 13.0001 18.3544 13.4937 17.9558 14.2156C17.6443 14.7797 17.1449 15.3334 16.5006 15.3334C15.8562 15.3334 15.319 14.8029 15.4785 14.1786C15.9936 12.162 17.8257 10.6667 20.0006 10.6667C22.5739 10.6667 24.6672 12.7601 24.6672 15.3334C24.6672 17.7729 22.229 18.3791 21.4265 20.0442Z",
    fill: "#048760"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5645_25730"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "white",
    height: "40",
    width: "40"
  }))));
}